import React from "react"
import { StyledSvg } from './styles';

function Icon({ control, play, specialColor }: { control: () => void; play?: boolean, specialColor?: string }) {
  return (
    <StyledSvg
      onClick={() => {
        if (typeof control === "function") {
          control()
        }
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      version="1.1"
      viewBox="0 0 60 60"
      style={{
        cursor: "pointer",
        flexShrink: 0
      }}
    >
      <defs>
        <mask id="Mask1018" width="2" height="2" x="-1" y="-1">
          <path fill="#fff" d="M10 10H50V50H10z"></path>
          <path d="M10 30c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20z"></path>
        </mask>
        <filter
          id="Filter1022"
          width="80"
          height="80"
          x="-10"
          y="-10"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceGraphic" result="FeOffset1023Out"></feOffset>
          <feGaussianBlur
            in="FeOffset1023Out"
            result="FeGaussianBlur1024Out"
            stdDeviation="4 4"
          ></feGaussianBlur>
        </filter>
      </defs>
      <g filter="url(#Filter1022)">
        <path
          fill="none"
          strokeWidth="0"
          d="M10 30c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20z"
          mask='url("#Mask1018")'
        ></path>
        <path
          fill={specialColor ? specialColor : "#df4a32"}
          d="M10 30c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20z"
        ></path>
      </g>
      <path
        fill={specialColor ? specialColor : "#df4a32"}
        d="M10 30c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20z"
      ></path>
      <g>
        {!play ? (
          <path
            fill="#dad2d2"
            d="M32 25l6 10H26z"
            transform="rotate(90 32 30)"
          ></path>
        ) : (
          <>
            <rect x={26} y={25} fill={"#dad2d2"} width={3} height={10}></rect>
            <rect x={32} y={25} fill={"#dad2d2"} width={3} height={10}></rect>
          </>
        )}
      </g>
    </StyledSvg>
  )
}

export default Icon
